module.exports = __webpack_public_path__ + "static/media/aboutusbg.8009dafb.png";